<template>
    <div class="advertisting-register-pop" :style="popStyle">
        <div
            class="adv-progress-wrap mobile-progress"
            v-if="isMobileSize && index"
        >
            <AdvProgress :value="computedProgress()"></AdvProgress>
        </div>
        <component
            :is="comp"
            :options="options"
        ></component>
    </div>
</template>

<script>
import AdvProgress from './step/components/progress.vue';
import BudgetRange from './step/BudgetRange.vue';
import BudgetBtn from './step/BudgetBtn.vue';
import Beds from './step/Beds.vue';
import Baths from './step/Baths.vue';
import Sqft from './step/Sqft.vue';
import Contact from './step/Contact.vue';
import Email from './step/Email.vue';
import LeadName from './step/LeadName.vue';
import Phone from './step/Phone.vue';
import searchParamsMixin from './searchParams.mixin.js';
import util from '@/common/util';

export default {
    props: {
        options: {
            type: Object,
            default: () => ({})
        },
        changeType: Function,
        changeAllowClose: Function
    },
    mixins: [searchParamsMixin],
    data: function() {
        return {
            order: [
                'BudgetRange',
                'Beds',
                'Baths',
                'Sqft',
                'Contact',
                'Email',
                'LeadName',
                'Phone'
            ],
            index: 0
        };
    },
    computed: {
        isMobileSize() {
            return this.platform.isMobile
        },
        comp: function({ index }) {
            return this.order[index];
        },
        popStyle({ isMobileSize, index, order }) {
            if (
                order[index] &&
                order[index] === 'BudgetRange' &&
                !isMobileSize
            ) {
                return {
                    width: '580px'
                };
            } else {
                return {
                    width: '480px'
                };
            }
        }
    },
    provide() {
        return {
            next: util.debounce(this.handleNext, 300),
            progress: this.computedProgress,
            getComp: this.hasComp
        };
    },
    created() {
        if (!this.hasComp()) {
            throw new Error('The index of step is out of range.');
        }
        this.res = {};
    },
    methods: {
        /**
         * @desc { Collect parameters for each step }}
         * @param {stepConfig} Object
         * @param {key} String  new key
         * @param {callback} Function  final callback
         */
        handleNext(stepConfig, key = '', callback) {
            if (key) {
                if (!(key in this.res)) {
                    this.res[key] = {}; 
                }
                Object.assign(
                    this.res[key],
                    stepConfig instanceof Object ? stepConfig : {}
                );
            } else {
                Object.assign(
                    this.res,
                    stepConfig instanceof Object ? stepConfig : {}
                );
            }
            console.log(this.res);

            if (this.hasNextComp()) {
                this.index++;
            } else {
                // res -> req params
                this.res.dynamicRegister = true;
                callback && callback(this.res);
            }
        },
        hasNextComp() {
            return this.order[this.index + 1];
        },
        hasComp() {
            return this.comp;
        },
        computedProgress() {
            return Math.round((this.index * 100) / this.order.length - 1);
        }
    },
    components: {
        AdvProgress,
        BudgetRange,
        BudgetBtn,
        Beds,
        Baths,
        Sqft,
        Contact,
        Email,
        LeadName,
        Phone
    }
};
</script>

<style lang="scss">
@import '@/theme/mixin.scss';
@import '@/theme/media.scss';

.advertisting-register-pop {
    width: 480px;
    border-radius: 5px;
    box-shadow: 0 4px 10px 0 rgba(0, 10, 30, 0.1);
    background-color: #fff;
    text-align: center;
    margin: auto;
    @include media-600 {
        max-width: 90%;
        max-height: 90%;
    }
    .adv-progress-wrap.mobile-progress {
        margin: 0 30px;
        border-bottom: 1px solid #ebecf1;
        padding-top: 38px;
        .adv-progress {
            height: 15px;
            padding-bottom: 37px;
            .adv-progress-bar {
                margin-right: 19px;
            }
            .adv-progress__label {
                font-size: 12px;
                line-height: 15px;
                width: auto;
            }
        }
    }
    .adv-btn-group {
        padding-bottom: 30px;
        border-bottom: 1px solid #ebecf1;
        @include media-600 {
            padding: 0;
            border: 0;
            &.baths-choose {
                margin-top: 58px;
            }
            &.sqft-choose {
                margin-top: 55px;
            }
        }
        .adv-btn {
            margin-top: 12px;
            &:first-child {
                margin-top: 20px;
            }
            @include media-600 {
                margin-right: 0;
                margin-top: 10px;
                height: 48px;
                border-radius: 24px;
                line-height: 48px;
                font-size: 16px;
                &:first-child {
                    margin-top: 0;
                }
                &:active {
                    background-color: #4c84ff;
                    color: #fff;
                }
            }
            &:nth-child(even) {
                margin-right: 0;
            }
        }
    }
    .step {
        padding: 40px 30px 30px;
        &.bugget-range {
            padding: 40px 30px;
        }
        background: transparent
            url(https://cdn.chime.me/image/fs/sitebuild/2022221/21/original_5a4dc6e1-e94c-4640-9d3b-200e92404f3b.png)
            no-repeat center center;
        border-radius: 5px;
        &.pb-34 {
            padding-bottom: 34px;
        }
        &.pb-30 {
            padding-bottom: 30px;
        }
        .mb-30 {
            margin-bottom: 30px;
        }
        .pb-15 {
            padding-bottom: 15px;
        }
        .pt-34 {
            padding-top: 34px;
        }
        .pt-30 {
            padding-top: 30px;
        }
        .pb-30 {
            padding-bottom: 30px;
        }
        .pb-20 {
            padding-bottom: 20px;
        }
        .mt-8 {
            margin-top: 8px;
        }
        .mt-10 {
            margin-top: 10px;
        }
        .mt-24 {
            margin-top: 24px;
        }
        .mb-32 {
            margin-bottom: 32px;
        }
        .mb-4 {
            margin-bottom: 4px;
        }
        .mt-20 {
            margin-top: 20px;
        }
        .mb-20 {
            margin-bottom: 20px;
        }
        .mb-40 {
            margin-bottom: 40px;
        }
        .mb-10 {
            margin-bottom: 10px;
        }
        .mb-15 {
            margin-bottom: 15px;
        }
        .btop {
            border-top: 1px solid #ebecf1;
        }
        .bt {
            border-bottom: 1px solid #ebecf1;
        }
        @include media-600 {
            padding: 25px 30px;
            &.sqft {
                padding-bottom: 40px;
            }
            &.bugget-range {
                padding-bottom: 40px;
                .adv-range {
                    &.mb-40 {
                        margin-bottom: 245px;
                    }
                    .adv-range-thumb {
                        height: 10px;
                    }
                    .adv-price-range {
                        color: #797e8b;
                        font-size: 14px;
                        line-height: 12px;
                        span {
                            color: #4c84ff;
                        }
                    }
                }

                .adv-btn.primary.inline {
                    height: 48px;
                    border-radius: 24px;
                    font-size: 16px;
                    line-height: 48px;
                    font-family: var(--font-bold);
                }
                .range-list {
                    margin-top: 132px;
                }
            }
            &.beds {
                padding-bottom: 40px;
                .adv-btn-group {
                    margin-top: 39px;
                    .adv-btn {
                        &:first-child {
                            margin-top: 0;
                        }
                    }
                }
            }
            &.baths {
                padding-bottom: 40px;
                .adv-btn-group {
                    margin-top: 39px;
                }
            }
            &.contact {
                padding-bottom: 30px;
                .sut-1 {
                    line-height: 22px;
                }
                .adv-btn {
                    height: 48px;
                    line-height: 48px;
                    font-family: var(--font-bold);
                    font-size: 16px;
                    border-radius: 24px;
                    &.mb-10 {
                        margin-top: 137px;
                    }
                    &.mb-15 {
                        margin-bottom: 15px;
                    }
                }
                .adv-desc.pb-30.bt {
                    font-size: 14px;
                    color: #515666;
                    border: 0;
                    padding-bottom: 0;
                }
            }
            &.email {
                padding-bottom: 30px;
                .adv-subtitle {
                    font-size: 14px;
                    line-height: 24px;
                }
                .adv-title.mt-8.mb-10 {
                    margin-top: 10px;
                    margin-bottom: 30px;
                }
                .mb-15.adv-btn {
                    margin-top: 118px;
                    height: 48px;
                    line-height: 48px;
                    border-radius: 24px;
                    font-family: var(--font-bold);
                    font-size: 16px;
                }
                .adv-desc.bt.pb-30 {
                    font-size: 14px;
                    color: #515666;
                    border: 0;
                    padding: 0;
                }
            }
            &.lead-name {
                padding-bottom: 30px;
                .adv-subtitle {
                    line-height: 24px;
                    font-size: 14px;
                }
                .adv-title.mt-8.mb-20 {
                    margin-top: 10px;
                    margin-bottom: 30px;
                }
                .adv-input input {
                    height: 48px;
                    line-height: 48px;
                    border-radius: 24px;
                }
                .mb-30.adv-btn.primary.inline.mt-10 {
                    margin-top: 135px;
                    margin-bottom: 15px;
                    line-height: 48px;
                    height: 48px;
                    border-radius: 24px;
                    font-family: var(--font-bold);
                    font-size: 16px;
                }
                .adv-desc.bt.pb-30 {
                    color: #515666;
                    font-size: 14px;
                    line-height: 18px;
                    font-family: var(--font-normal);
                    border: 0;
                    padding: 0;
                }
            }
            &.phone {
                padding-bottom: 30px;
                .adv-subtitle {
                    font-size: 14px;
                    line-height: 24px;
                }
                .adv-title.mt-8.mb-20 {
                    margin-top: 10px;
                    margin-bottom: 30px;
                }
                .adv-input {
                    input {
                        line-height: 48px;
                        height: 48px;
                        border-radius: 24px;
                    }
                }
                .mb-30.adv-btn.primary.inline.mt-10 {
                    line-height: 48px;
                    height: 48px;
                    font-size: 16px;
                    font-family: var(--font-bold);
                    border-radius: 24px;
                    margin-bottom: 15px;
                }
                .adv-desc {
                    font-size: 12px;
                    line-height: 17px;
                    color: #a0a3af;

                    &.bt.pb-30 {
                        font-size: 14px;
                        line-height: 18px;
                        color: #515666;
                        padding-bottom: 35px;
                        border: 0;
                    }
                }
            }
            .mb-4 {
                margin-bottom: 10px;
            }
        }
    }
}
</style>
